import type { KeyboardEvent } from 'react';

/**
 * `onKeyDown` do `<form>`: Enter num campo de texto NÃO envia o formulário.
 *
 * O navegador submete o form quando se aperta Enter num `<input>` — e em
 * formulário longo (perfil, endereço) a pessoa aperta Enter achando que vai
 * para o próximo campo e salva pela metade. Aqui só o botão salva.
 *
 * Textarea continua quebrando linha e botão continua sendo acionado pelo Enter
 * (é o próprio "Salvar" com foco): o bloqueio é só para `<input>`.
 */
export function bloquearEnvioPorEnter(evento: KeyboardEvent<HTMLFormElement>): void {
  if (evento.key !== 'Enter') return;

  const alvo = evento.target as HTMLElement;
  if (alvo instanceof HTMLInputElement && !['submit', 'button', 'checkbox', 'radio'].includes(alvo.type)) {
    evento.preventDefault();
  }
}
